export enum CategoryEnum{
  ALL = 'ALL',
  CRYPTO = 'CRYPTO',
  METAL = 'METAL',
  INDEX = 'INDEX',
  EQUITY = 'EQUITY',
  ENERGY = 'ENERGY',
  FOREX = 'FOREX',
}
